import { render, staticRenderFns } from "./max-table.vue?vue&type=template&id=e8dc7e4e&"
import script from "./max-table.vue?vue&type=script&lang=js&"
export * from "./max-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports